import { Dispatch } from 'react';
import * as ActionTypes from 'src/constants/ActionTypes';
import { IStateMallBrand, IStoreState } from 'src/entity/StateEntity';
import { IMallBrand } from '../../entity/MallEntity';
import { MallService } from '../../services/MallService';

export function reloadMallBrand(): IStateMallBrand {
  return {
    reload: true,
    isFetching: false,
    type: ActionTypes.MALL_BRAND_STATUS_RELOAD,
    brandList: [],
  };
}

export function requestMallBrand(): IStateMallBrand {
  return {
    reload: false,
    isFetching: true,
    type: ActionTypes.MALL_BRAND_STATUS_REQUEST,
    brandList: [],
  };
}

function receiveMallBrand(brandList: IMallBrand[], isSuccess: boolean): IStateMallBrand {
  return {
    reload: !isSuccess,
    isFetching: false,
    type: isSuccess ? ActionTypes.MALL_BRAND_STATUS_SUCCESS : ActionTypes.MALL_BRAND_STATUS_FAILURE,
    brandList,
  };
}

export function fetchMallBrand(): any {
  return async (dispatch: Dispatch<IStateMallBrand>) => {
    dispatch(requestMallBrand());
    return MallService.getAllMallBrand()
      .then(res => dispatch(receiveMallBrand(res.results, true)))
      .catch(error => dispatch(receiveMallBrand([], false)));
  };
}

export function shouldFetchMallBrand(mallBrandState: IStateMallBrand): boolean {
  return (mallBrandState.reload || mallBrandState.brandList.length === 0) && !mallBrandState.isFetching;
}

export function fetchMallBrandIfNeeded(): any {
  return (dispatch: Dispatch<IStateMallBrand>, getState: any) => {
    const { mallBrandState } = getState() as IStoreState;
    if (shouldFetchMallBrand(mallBrandState)) {
      return dispatch(fetchMallBrand());
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/mallBrandCreator.ts